import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Defaults to localStorage
import themeSettingSlice from './themeSettingSlice';
import sidebarSlice from './sidebarSlice';
import authSlice from './slicers/authSlice';
import languageSlice from './slicers/languageSlice';
import studentSlice from './slicers/studentSlice';
import instanceSlice from './slicers/instanceSlice';

// Configure persistence specifically for the auth slice
const authPersistConfig = {
  key: 'auth',
  storage,
};
const studentPersistConfig = {
  key: 'student',
  storage,
};
const instancePersistConfig = {
  key: 'instance',
  storage,
};
// Persist slices
const persistedAuthReducer = persistReducer(authPersistConfig, authSlice);
const persistedStudent = persistReducer(studentPersistConfig, studentSlice);
const persistedInstance = persistReducer(instancePersistConfig, instanceSlice);

// Configure the store with persisted and non-persisted reducers
const store = configureStore({
  reducer: {
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    instance: persistedInstance,
    authSlice: persistedAuthReducer, // Persist only auth slice
    language: languageSlice,
    student: persistedStudent,
    
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          // 'persist/PAUSE',
          // 'persist/FLUSH',
          // 'persist/PURGE',
          // 'persist/REGISTER',
        ]
      }
    })
});

// Create a persistor for managing persistence
const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store, persistor };
